var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/~/lodash/_getPrototype.js
// module id = 616
// module chunks = 0